/* ============================================
   NYAS Motion — Scroll Reveal Trigger
   Watches for .nyas-reveal / .nyas-reveal-group
   and adds .is-visible when scrolled into view
   ============================================ */
(function () {
  if (!("IntersectionObserver" in window)) {
    document.querySelectorAll(".nyas-reveal, .nyas-reveal-group").forEach(function (el) {
      el.classList.add("is-visible");
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.15,
      rootMargin: "0px 0px -60px 0px"
    }
  );

  function init() {
    document.querySelectorAll(".nyas-reveal, .nyas-reveal-group").forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();